export const StampTemplateFragment = gql`
  fragment StampTemplateFragment on StampTemplate {
    archivedAt
    borderWidth
    color
    createdAt
    defaultOpacity
    heightInches
    id
    name
    showBorder
    updatedAt
    uuid
    widthInches

    archivedByUser {
      ...UserDataFragment
    }
    configConnections {
      ...ConfigConnectionFragment
    }
    items {
      ...StampTemplateItemFragment
    }
  }
  fragment StampTemplateItemFragment on StampTemplateItem {
    fontSize
    heightInches
    id
    isBolded
    isItalicized
    isUnderlined
    opacity
    rotation
    text
    textAlignment
    type
    widthInches
    xInches
    yInches

    file {
      ...FileFragment
    }
  }
`
